// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__Z7zG-","header":"ClearentDisclaimer_header__31keo","inner":"ClearentDisclaimer_inner__2YzFK"};